import compose from 'ramda/src/compose';
import split from 'ramda/src/split';
import head from 'ramda/src/head';
import path from 'ramda/src/path';
import prop from 'ramda/src/prop';
import slice from 'ramda/src/slice';
import is from 'ramda/src/is';
import join from 'ramda/src/join';
import call from 'ramda/src/call';
import ifElse from 'ramda/src/ifElse';
import partialRight from 'ramda/src/partialRight';
var splitByDot = split('.');
var firstByDot = compose(head, splitByDot);
var componentTokenPath = compose(join('.'), slice(1, Infinity), splitByDot);
var themePropSelector = theme => partialRight(prop, [theme]);
var themePathSelector = theme => partialRight(path, [theme]);
var predicate = theme => compose(is(Function), themePropSelector(theme), firstByDot);
var componentTokenSelector = theme => path => compose(partialRight(call, [componentTokenPath(path)]), themePropSelector(theme), firstByDot)(path);
var themeTokenSelector = theme => compose(themePathSelector(theme), splitByDot);
var selectTheme = path => _ref => {
  var {
    theme
  } = _ref;
  return ifElse(predicate(theme), componentTokenSelector(theme), themeTokenSelector(theme))(path);
};
export { selectTheme };